module.exports = __webpack_public_path__ + "static/media/logow.41f65f75.png";